module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_EE-68195be7249751a93c49f0cc672eb061.svg";